import {
    getScreen,   
    
} from '@/api/screen'
import {getToken} from '@/utils/auth'



// 用户记录
const state = {
    screenSet: [],
   
};

const mutations = {    
    screenSet: (state, list) => {
        state.screenSet = list;
    },
   
}

const actions = {

    async screenSet({commit, state},{}) {
        return getScreen({userId: getToken()}).then(response => {
            // console.log('asfasdfsafdasddsasdfsadfsdf',response.data)
            commit('screenSet', response.data);
        });
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
